import styled from "styled-components";

const FONT_STACK = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;

export const ContainerCard = styled.div`
  display: flex;
  flex-direction: row;
  width: 370px;
  height: auto;
  background: linear-gradient(
    155deg,
    var(--violetaOscuro) 0%,
    var(--violetaPastelOscuro) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  margin: 12px;
  color: var(--blanco);
  font-family: ${FONT_STACK};
  font-feature-settings: "cv11", "ss01", "ss03", "cv02";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.08),
    0 4px 12px -2px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  position: relative;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(
      90deg,
      var(--naranjaOscuro) 0%,
      var(--violetaPastel) 100%
    );
  }

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(255, 255, 255, 0.18);
    box-shadow:
      0 2px 4px rgba(0, 0, 0, 0.1),
      0 12px 24px -6px rgba(0, 0, 0, 0.22);
  }

  @media (max-width: 800px) {
    width: 100%;
    flex-direction: column;
  }
`;

export const ContainerLabel = styled.div`
  text-align: start;
  height: 100%;
  padding: 2px 0;

  select {
    color: var(--blanco);
    background-color: rgba(255, 255, 255, 0.08);
    font-family: ${FONT_STACK};
    font-size: 0.78rem;
    font-weight: 500;
    letter-spacing: -0.005em;
    padding: 8px 32px 8px 12px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 6px;
    width: calc(100% - 28px);
    margin: 4px 14px;
    cursor: pointer;
    transition:
      background-color 0.15s ease,
      border-color 0.15s ease,
      box-shadow 0.15s ease;
    appearance: none;
    -webkit-appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;

    &:hover:not(:disabled) {
      background-color: rgba(255, 255, 255, 0.14);
      border-color: rgba(255, 255, 255, 0.28);
    }

    &:focus {
      outline: none;
      border-color: var(--violetaPastel);
      box-shadow: 0 0 0 3px rgba(203, 182, 219, 0.2);
    }

    &:disabled {
      opacity: 0.55;
      cursor: not-allowed;
    }

    option {
      background-color: var(--violetaOscuro);
      color: var(--blanco);
      font-family: ${FONT_STACK};
    }
  }

  #cardTitle {
    display: block;
    padding: 6px 16px 2px 16px;
    font-family: ${FONT_STACK};
    font-size: 1.05rem;
    font-weight: 600;
    letter-spacing: -0.015em;
    line-height: 1.3;
    color: var(--blanco);
  }

  #cardSubtitle {
    display: block;
    padding: 2px 16px;
    font-family: ${FONT_STACK};
    font-size: 0.78rem;
    font-weight: 400;
    line-height: 1.45;
    letter-spacing: -0.005em;
    color: rgba(255, 255, 255, 0.72);
  }

  #cardPrice {
    display: block;
    padding: 12px 16px 14px 16px;
    text-align: center;
    font-family: ${FONT_STACK};
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -0.025em;
    color: var(--blanco);
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum", "cv11";
  }

  @media (max-width: 800px) {
    text-align: center;
    height: auto;
    #cardTitle,
    #cardSubtitle,
    #cardPrice {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

export const BotonReset = styled.button`
  width: 100%;
  height: 100%;
  padding: 10px;
  border: none;
  border-radius: 0 0 10px 10px;
  color: white;
  font-family: ${FONT_STACK};
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.04em;
  background: linear-gradient(180deg, #8b1219 0%, #700e14 100%);
  cursor: pointer;
  transition:
    background 0.15s ease,
    transform 0.08s ease;

  &:hover {
    background: linear-gradient(180deg, #b42e30 0%, #8b1219 100%);
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 800px) {
    width: 30%;
    padding: 8px;
    font-size: 0.78rem;
  }

  @media (min-width: 801px) and (max-width: 1023px) {
    width: 30%;
    padding: 8px;
    font-size: 0.78rem;
  }
`;

export const BotonConfirm = styled.button`
  width: 100%;
  height: 100%;
  padding: 10px;
  border: none;
  border-radius: 0 0 10px 10px;
  color: white;
  font-family: ${FONT_STACK};
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.04em;
  background: linear-gradient(180deg, #1a7d1d 0%, #136015 100%);
  cursor: pointer;
  transition:
    background 0.15s ease,
    transform 0.08s ease;

  &:hover {
    background: linear-gradient(180deg, #399b3e 0%, #1a7d1d 100%);
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 800px) {
    width: 30%;
    padding: 10px;
    font-size: 0.78rem;
  }

  @media (min-width: 801px) and (max-width: 1023px) {
    width: 100%;
    padding: 8px;
    font-size: 0.78rem;
  }
`;

export const ContainetButton = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 0 0 10px 10px;
  margin-top: 10px;
`;

export const ContainerImage = styled.div`
  max-height: 250px;
  width: 100%;
  border-radius: 10px 0 0 10px;
  overflow: hidden;
  img {
    border-radius: 10px 0 0 10px;
    height: 100%;
    width: 100%;
    background-size: auto;
  }

  @media (max-width: 800px) {
    height: 250px;
    border-radius: 10px 10px 0 0;
    img {
      border-radius: 10px 10px 0 0;
    }
  }
`;

export const ContainerDetails = styled.div`
  padding: 14px 0 0 0;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
`;
